// Copyright 2024, Imprivata, Inc.  All rights reserved.

import { Tabs } from '@imprivata-cloud/components';

import { useTranslation } from 'react-i18next';
import { withRole } from '../../../common/authorization/Roles';
import { ROLE_TYPE_ADMIN } from '../../constants';
import Appearance from '../appearance/Appearance';
import IdentityUsers from '../identityUsers/IdentityUsers';
import Integrations from '../integrations/Integrations';
import Users from '../users/Users';

import './Settings.less';

const TRANSLATION_ROOT = 'portal.settings.tabs-title';

export const Settings = ({ activeTab }: { activeTab?: string }) => {
  const { t } = useTranslation();

  const tabItems = [
    {
      key: 'users',
      label: t(`${TRANSLATION_ROOT}.entra-id-users`),
      children: <Users />,
    },
    {
      key: 'identity-users',
      label: t(`${TRANSLATION_ROOT}.identity-users`),
      children: <IdentityUsers />,
    },
    {
      key: 'integrations',
      label: t(`${TRANSLATION_ROOT}.integrations`),
      children: <Integrations />,
    },
    { key: 'customize', label: t(`${TRANSLATION_ROOT}.customize`), children: <Appearance /> },
  ];

  return (
    <>
      <div className="settings-header">
        <h1>{t('portal.settings.title')}</h1>
      </div>
      <div className="settings-tab-container scroll-parent">
        <Tabs
          tabItems={tabItems}
          type="card"
          size="large"
          data-testid="settings-tabs"
          defaultActiveKey={activeTab || 'users'}
        />
      </div>
    </>
  );
};

export default withRole({ authorizedRoles: [ROLE_TYPE_ADMIN] })(Settings);
